import { FC, ReactNode } from 'react';

import { ElementSpyInstance } from 'bloko/common/elementSpy';

// eslint-disable-next-line no-restricted-imports
import useElementShown, { GenericSendElementShown } from './useElementShown';

interface ElementShownAnchorCommonProps {
    /** Элемент используемый в качестве якоря */
    Element?: 'div' | 'span' | 'p';
    /** Имя класса для якоря */
    className?: string;
    /** Дочерние элементы */
    children?: ReactNode;
}

/**
 * Хелпер для создания интерфейса компонента из параметров аналитического метода
 */
type ElementShownAnchorPropsHelper<FN, E = HTMLElement> = FN extends (element: E, params: infer P) => ElementSpyInstance
    ? { fn: FN } & P
    : FN extends (element: E) => ElementSpyInstance
    ? { fn: FN }
    : never;

/**
 * Компонент создаёт якорь для отправки аналитики при его попадании во вьюпорт
 *
 * Принимает типизированный аналитический метод и все его параметры в виде пропов
 *
 * При изменении изначений пропов событие инициализируется заново
 */
const ElementShownAnchor = <M extends unknown = GenericSendElementShown>({
    Element = 'div',
    className,
    children,
    fn,
    ...params
}: ElementShownAnchorCommonProps & ElementShownAnchorPropsHelper<M>): ReturnType<FC> => {
    const ref = useElementShown(fn, params);
    return (
        <Element ref={ref} className={className}>
            {children}
        </Element>
    );
};

export default ElementShownAnchor;
